export default __webpack_public_path__ + "static/cabezote-ac4a30e56c72f12b0dcfe8ce54304b21.png";